import { Component, OnInit, EventEmitter, Input, OnDestroy, OnChanges, SimpleChanges, Output } from '@angular/core';
import { EditService, EditCardColumn } from 'app/services/edit.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { DomainService, GivColumnDomain } from 'app/services/domain.service';
import { UserService } from 'app/services/user.service';
import { ActivityService } from 'app/services/activity.service';
import { AppLayer } from 'app/services/layer.service';
import { MainDataService, ModelMenuItemKey } from 'app/services/main-data.service';
import { Subscription } from 'rxjs';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { MainDataMapLayersService } from 'app/services/main-data-map-layers.service';
import { ActiveToast, ToastrService } from 'ngx-toastr';

export interface EditDataEmitter {
	// isInitEdit?: boolean;
	// deleteStatusChange?: boolean;
	recId: any;
	card;
	changedCol?: string;
}
export interface SelectRecordEmitter {
	id: string;
}
export interface EditRecordListChangeData {
	editList: any[];
}

export type CardDisplayMode = 'selection' | 'edit';

@Component({
	selector: 'app-edit-card',
	templateUrl: './edit-card.component.html',
	styleUrls: ['./edit-card.component.css']
})
export class EditCardComponent implements OnInit, OnDestroy, OnChanges {

	@Input() columns: EditCardColumn[];
	@Input() getRecordId: (rec) => string;

	@Input() disableEditing: boolean;
	@Input() hideAddButton: boolean;

	currentList: any[];
	displayMode: CardDisplayMode;
	// @Input() selectedRecord;
	selectedRecord; // Current card
	private currentCardId;

	selectionList: any[] = [];
	editRecordList: any[] = [];
	isEditedListCurrent: boolean;
	// private selectedRecordOrigin;

	domainsByColumn: {
		[prop: string]: GivColumnDomain;
	}

	modelKey: ModelMenuItemKey;

	showCarryAttrTool: boolean;
	isCarryingAttr: boolean;
	carryAttrToast: ActiveToast<any>;

	isEditedCol: string;
	toDeleteCol: string;
	isNewKey: string;
	qcClassCol: string;
	isIdOnlyKey: string;
	nguidStandardCol: string;

	commitDisableReason = ''; // TODO

	// neighborOption = 'get_neighbor';

	// @Output() edit: EventEmitter<EditDataEmitter> = new EventEmitter();
	@Output() clickDiscard: EventEmitter<any> = new EventEmitter();
	@Output() clickCommit: EventEmitter<any> = new EventEmitter();
	@Output() clickAdd: EventEmitter<any> = new EventEmitter();
	// @Output() selectRecord: EventEmitter<SelectRecordEmitter> = new EventEmitter();
	// @Output() onEditRecordListChange: EventEmitter<EditRecordListChangeData> = new EventEmitter();

	// private selectedRecordSub: Subscription;

	private selectedLayerSub: Subscription;
	private selectedRecordsSub: Subscription;
	private editListSub: Subscription;
	private currentCardSub: Subscription;
	private dataIndexObjSub: Subscription;
	private modelSub: Subscription;
	constructor(
		private toastr: ToastrService,
		private activityService: ActivityService,
		private attrIndexService: AttrIndexService,
		private domainService: DomainService,
		private editService: EditService,
		private mainDataService: MainDataService,
		private mapService: MainDataMapService,
		private mapLayerService: MainDataMapLayersService,
		private userService: UserService
	) { }
	async onChange(col?: EditCardColumn, isOnlyGeomChange?: boolean, isDeleteChange?: boolean, isStateOrCountyCol?: boolean) {
		if (!this.selectedRecord) {
			return;
		}
		const cateCode = this.activityService.selectedLayerBS.getValue().layer.category.code;
		// const data: EditDataEmitter = {
		// 	recId: this.getRecordId(this.selectedRecord),
		// 	card: this.selectedRecord,
		// 	changedCol: col ? col.prop : null
		// 	// deleteStatusChange: deleteStatusChange
		// }
		// if (isDeleteChange) {
		// 	data.changedCol = this.toDeleteCol;
		// }
		if (!this.selectedRecord[this.isEditedCol]) {
			if (!this.selectedRecord[this.isEditedCol]) {
				this.mainDataService.addRecToCard(this.getRecordId(this.selectedRecord), null, 'card');
			}
			// this.addCardToList(this.selectedRecord);
			// data.isInitEdit = true;
		}
		if (col && !isOnlyGeomChange) {
			if (this.domainsByColumn[col.prop] && this.domainsByColumn[col.prop].type === 'list') {
				this.domainService.updateDependentDomains(this.domainsByColumn, {
					prop: col.prop,
					standardName: col.info.standardColName
				}, this.selectedRecord, cateCode);
			}
			// if (isStateOrCountyCol && col.info.standardColName === this.stateColStandard) {
			// 	if () {

			// 	}
			// } else {
			// 	this.editCardService.updateDependentDomains(this.selectedRecord, this.columns, col);
			// }	
		}
		const triggeredChanges = this.editService.editTrigger(cateCode, this.selectedRecord, col.prop, this.selectedRecord[col.prop])
		Object.keys(triggeredChanges).forEach(i => {
			this.selectedRecord[i] = triggeredChanges[i];
		});

		if (col && col.isAnchored) {
			this.updateListToAnchoredValue(col);
		}
		// this.edit.emit(data);
	}
// 	async onChangeStateOrCounty(col: EditCardColumn, newValue, selectEl: HTMLSelectElement) {
// // 		if (newValue === this.neighborOption) {


// // // TODO



// // 			const neighbors = await this.domainService.getNagNeighbors(this.userService.customerInfo.givState, this.userService.customerInfo.cusCounties[0])
// // 			col.info.neighborList = neighbors;
// // 			// console.log(selectEl)
// // 			// debugger
// // 			// selectEl.value = this.selectedRecord[col.prop];
// // 			setTimeout(() => {
// // 				selectEl.selectedIndex = neighbors.indexOf(this.selectedRecord[col.prop]);
// // 			});
// // 			return;
// // 		}
// // 		this.selectedRecord[col.prop] = newValue;
// // 		this.onChange(col, null, null, true);
// 	}
	onChangeDelete(isDelete: boolean) {
		if (this.selectedRecord[this.isNewKey]) {
			const id = this.getRecordId(this.selectedRecord);
			this.mainDataService.removeDataFromStoredRecords(id);
			const editedIds = this.activityService.editRecordListBS.getValue().ids;
			editedIds.splice(editedIds.indexOf(id), 1);
			this.activityService.editRecordListBS.next({
				ids: editedIds,
				source: 'card'
			});
		} else {
			this.selectedRecord[this.toDeleteCol] = isDelete;
			this.onChange(null, null, true);
		}
	}
	checkValueInDomain(col: EditCardColumn) {
		if (!this.selectedRecord[col.prop] && this.selectedRecord[col.prop] !== 0) {
			return;
		}
		const domain = this.domainsByColumn[col.prop];
		if (domain && domain.type === 'list') {
			if (!domain.list) {
				return;
			}
			let idx = domain.list.indexOf(this.selectedRecord[col.prop]);
			if (idx < 0 && col.info.neighborList) {
				idx = col.info.neighborList.indexOf(this.selectedRecord[col.prop]);
			}
			if (idx < 0) {
				return false;
			} else {
				return true;
			}
		}
	}
	checkCellEditDisable(col: EditCardColumn) {
		if (col.info.isEditDisabled || this.selectedRecord[this.toDeleteCol] || this.disableEditing) {
			return true;
		}
	}
	//
	// private addCardToList(rec) {
	// 	if (!rec[this.isEditedCol]) {
	// 		// rec[this.isEditedCol] = true;
	// 		// this.editRecordList.push(rec);
	// 		this.mainDataService.addRecToCard(this.getRecordId(rec), null, 'card');
	// 			// // Store the original data
	// 			// this.editService.originRecordList.push(origin);
	// 		// // Trigger change
	// 		// this.onEditRecordListChange.emit({
	// 		// 	editList: this.editRecordList
	// 		// });
	// 	}
	// }

	private changeSelectedRecord(recId, skipTrigger?: boolean) {
		this.currentCardId = recId;
		if (recId) {
			this.selectedRecord = this.mainDataService.getDataAttrs(recId);
		} else {
			this.selectedRecord = null;
		}
		// Check show carryAttr tool
		this.checkCarryAttrTool();
		//
		if (this.selectedRecord) {
			// Get domains
			const layerCate = this.activityService.selectedLayerBS.getValue().layer.category;
			const cols = this.columns.map(c => {
				return {
					prop: c.prop,
					standard: layerCate.standardCols.find(s => s.colName === c.info.standardColName)
				}
			});
			this.domainsByColumn = this.domainService.getColumnDomains(cols, layerCate.code, this.selectedRecord);
		}
		if (!skipTrigger) {
			this.activityService.currentCardBS.next({
				id: recId,
				source: 'card'
			});
		}

		//
		// if (!skipTrigger) {
		// 	this.selectRecord.emit({
		// 		id: recId
		// 	});
		// }
	}

	checkCommitDisabled() {
		return this.displayMode!=='edit' || !this.editRecordList.length;
	}
	goPrevRecord() {
		const idx = this.currentList.indexOf(this.selectedRecord);
		if (idx <= 0) {
			return;
		}
		const id = this.getRecordId(this.currentList[idx - 1]);
		this.changeSelectedRecord(id);
	}
	goNextRecord() {
		const idx = this.currentList.indexOf(this.selectedRecord);
		if (idx >= this.currentList.length - 1) {
			return;
		}
		const id = this.getRecordId(this.currentList[idx + 1]);
		this.changeSelectedRecord(id);
	}

	toggleAnchor(col: EditCardColumn) {
		if (this.disableEditing) {
			return;
		}
		col.isAnchored = !col.isAnchored;
		// if (col.isAnchored) {
		// 	this.updateListToAnchoredValue(col);
		// }
	}
	onMouseenterAnchor(col: EditCardColumn) {
		if (this.disableEditing) {
			return;
		}
		col.mouseoverAnchor = true;
	}
	onMouseleaveAnchor(col: EditCardColumn) {
		if (this.disableEditing) {
			return;
		}
		setTimeout(() => {
			col.mouseoverAnchor = false;
		}, 200);
	}
	private updateListToAnchoredValue(col: EditCardColumn) {
		this.currentList.forEach(r => {
			if (r !== this.selectedRecord) {
				r[col.prop] = this.selectedRecord[col.prop];
				if (!r[this.isEditedCol]) {
					this.mainDataService.addRecToCard(this.getRecordId(r), null, 'card');
				}
				// r[col.prop] = this.selectedRecord[col.prop]
			}
		});
	}

	checkQcClass(col: EditCardColumn, type: 'exception' | 'warning' | 'error') {
		const qcClassByCol = this.selectedRecord[this.attrIndexService.cardQcClassColName];
		if (qcClassByCol && qcClassByCol[col.prop]) {
			switch (type) {
				case 'exception':
					return qcClassByCol[col.prop] === 'qc-exception-cell';
				case 'warning':
					return qcClassByCol[col.prop] === 'qc-warning-cell';
				case 'error':
					return qcClassByCol[col.prop] === 'qc-error-cell';
			}
		}
	}
	checkFieldDirty(col: EditCardColumn) {
		const originAttrs = this.mainDataService.getDataOriginAttrs(this.getRecordId(this.selectedRecord));
		if (originAttrs) {
			return this.editService.hasValueChanged(this.selectedRecord[col.prop], originAttrs[col.prop]);
		}
	}

	onClickCarryAttr() {
		const onEnd = () => {
			this.isCarryingAttr = false;
			if (this.carryAttrToast) {
				this.toastr.remove(this.carryAttrToast.toastId);
				this.carryAttrToast = null;
			}
		}
		if (this.isCarryingAttr) {
			this.mapService.endPickOnMap(this.mapService.map);
			onEnd();
		} else {
			this.carryAttrToast = this.toastr.info('Copy attributes from - Select source feature', null, {
				disableTimeOut: true
			});
			this.isCarryingAttr = true;
		}
		const layerNames = [this.mapLayerService.dataLayerName, this.mapLayerService.bgSurroundingsLayerName];
		this.mapService.startPickOnMap(this.mapService.map, layerNames, (e) => {
			const feat = e.feat;
			const attrs = this.mainDataService.getDataAttrs(feat.getId());
			if (attrs) {
				const changedProps = {};
				const layerCate = this.activityService.selectedLayerBS.getValue().layer.category;
				const cols = layerCate.standardCols;
				cols.forEach(c => {
					if (c.isCarryRclCol) {
						const propWithPrefix = layerCate.colPrefix + '_' + c.colName.toLowerCase();
						changedProps[propWithPrefix] = attrs[propWithPrefix];
					}
				});
				Object.keys(changedProps).forEach(key => this.mainDataService.setDataAttrs(this.getRecordId(this.selectedRecord), key, changedProps[key]));
			}
		}, (e) => {
			onEnd();
			this.toastr.success('Copied!', null, {
				timeOut: 1000
			});
		});
	}

	addCard() {
		this.clickAdd.emit();
	}
	commit() {
		this.clickCommit.emit();
	}
	discard() {
		this.clickDiscard.emit();
	}

	changeDisplayMode(mode?: CardDisplayMode) {
		if (!mode) {
			mode = this.displayMode === 'selection' ? 'edit' : 'selection';
		}
		this.displayMode = mode;
		this.isEditedListCurrent = mode === 'edit';
		if (mode === 'edit') {
			this.currentList = this.editRecordList;
			if (this.editRecordList.indexOf(this.selectedRecord) === -1) {
				this.changeSelectedRecord(this.getRecordId(this.editRecordList[0]));
			}
		} else {
			this.currentList = this.selectionList;
			if (this.selectionList.indexOf(this.selectedRecord) === -1) {
				this.changeSelectedRecord(this.getRecordId(this.selectionList[0]));
			}
		}
	}

	private checkCarryAttrTool() {
		this.showCarryAttrTool = this.selectedRecord && this.activityService.selectedLayerBS.getValue().layer && this.activityService.selectedLayerBS.getValue().layer.category.code === this.attrIndexService.cateCodeCenterline;
	}

	ngOnInit() {

		let isInit = true;
		this.qcClassCol = this.attrIndexService.cardQcClassColName;
		this.isEditedCol = this.attrIndexService.isEditedKey;
		this.toDeleteCol = this.attrIndexService.isDeletedKey;
		this.isNewKey = this.attrIndexService.isNewDataKey;
		this.isIdOnlyKey = this.attrIndexService.isIdOnlyKey;
		this.nguidStandardCol = this.attrIndexService.nguidCol;

		this.changeDisplayMode('selection');

		this.dataIndexObjSub = this.mainDataService.dataIndexObjSubject.subscribe(() => {
			// const selectionList = []
			// this.selectionList.forEach(i => {
			// 	const rec = this.mainDataService.getDataAttrs(this.getRecordId(i));
			// 	if (rec) {
			// 		selectionList.push(rec);
			// 	}
			// })
			// const editList = [];
			// this.editRecordList.forEach(i => {
			// 	const rec = this.mainDataService.getDataAttrs(this.getRecordId(i));
			// 	if (rec) {
			// 		editList.push(rec);
			// 	}
			// })
			// this.currentList = this.currentList === this.selectionList ? selectionList : editList;
			// this.selectionList = selectionList;
			// this.editRecordList = editList;
			for (let i = 0; i < this.selectionList.length; i++) {
				const rec = this.mainDataService.getDataAttrs(this.getRecordId(this.selectionList[i]));
				if (rec) {
					this.selectionList[i] = rec;
				} // If rec doesn't exist, don't replace it, it will be replaced when dataIndex is populated
			}
			for (let i = 0; i < this.editRecordList.length; i++) {
				const rec = this.mainDataService.getDataAttrs(this.getRecordId(this.editRecordList[i]));
				if (rec) {
					this.editRecordList[i] = rec;
				}
			}
			if (this.currentCardId) {
				this.changeSelectedRecord(this.currentCardId);
			}
		});

		this.selectedLayerSub = this.activityService.selectedLayerBS.subscribe(data => {
			this.checkCarryAttrTool();
		});
		this.selectedRecordsSub = this.activityService.selectedRecordsBS.subscribe(data => {
			if (!data || !data.ids) {
				this.selectionList = [];
				return;
			}
			this.selectionList = data.ids.map(id => this.mainDataService.getDataAttrs(id));
			if (this.currentList !== this.selectionList) {
				this.changeDisplayMode('selection');
			}
		});
		this.editListSub = this.activityService.editRecordListBS.subscribe(data => {
			if (!data || !data.ids) {
				this.editRecordList = [];
				return;
			}
			this.editRecordList = data.ids.map(id => this.mainDataService.getDataAttrs(id));
			if (!isInit && this.currentList !== this.editRecordList) {
				this.changeDisplayMode('edit');
			}
		})
		this.currentCardSub = this.activityService.currentCardBS.subscribe(data => {
			if (!data || data.source === 'card') {
				return;
			}
			this.changeSelectedRecord(data.id, true);
		})
		isInit = false;

		this.modelSub = this.mainDataService.modelBS.subscribe(async data => {
			if (this.modelKey !== data) {
				this.modelKey = data;
			}
		});
	}
	ngOnDestroy() {
		this.dataIndexObjSub.unsubscribe();
		this.selectedLayerSub.unsubscribe();
		this.selectedRecordsSub.unsubscribe();
		this.editListSub.unsubscribe();
		this.currentCardSub.unsubscribe();
		this.modelSub.unsubscribe();
		// this.selectedRecordSub.unsubscribe();
	}
	ngOnChanges(changes: SimpleChanges) {
		// if (changes.currentCardId) { // && !changes.selectedRecord.firstChange
		// 	// if (this.selectedRecord) {
		// 	// 	this.selectedRecordOrigin = JSON.parse(JSON.stringify(this.selectedRecord));
		// 	// } else {
		// 	// 	this.selectedRecordOrigin = null;
		// 	// }
		// }
	}
}
